<template>
  <el-container>
    <el-header>
      <pg-header></pg-header>
    </el-header>
    <el-container class="el-body">
      <ir-slider>
        <el-aside>
          <pg-navmenu :datalist="datalist" v-if="loadNav"></pg-navmenu>
        </el-aside>
      </ir-slider>
      <el-main id="loadingArea">
        <router-view :key="key"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import IrSlider from '../../components/IrSlider'
import PgHeader from '../../components/PgHeader'
import PgNavmenu from '../../components/PgNavMenu'
import PgApidetail from '../../components/PgApiDetail'
import constant from '../../utils/constant'
import translation from '../../utils/translation'

// import { Loading } from 'element-ui'

// let loadingInstance

export default {
  data () {
    return {
      datalist: [],
      loadNav: false
    }
  },
  computed: {
    key () {
      return this.$route.path + '  ' + Math.random()
    }
  },
  components: {
    IrSlider,
    PgHeader,
    PgNavmenu,
    PgApidetail
  },
  created: function () {
    // this.createdLoadingInstance = Loading.service({
    //   background: 'rgba(0, 0, 0, 0.1)', // 背景颜色
    //   target: '#loadingArea' // 需要遮罩的区域
    // })
    this.initData()
  },
  beforeUpdate: function () {
    // loadingInstance = Loading.service({
    //   background: 'rgba(0, 0, 0, 0.1)', // 背景颜色
    //   target: '#loadingArea' // 需要遮罩的区域
    // })
  },
  updated: function () {
    // loadingInstance.close()
  },
  methods: {
    async initData () {
      let res = await this.getMenuMainTypeApi()
      let resChild = await this.getMenuMainApi()
      await this.initDataList(res, resChild)
    },
    async getMenuMainTypeApi () {
      let result
      await this.$api.menu.MenuMainTypeApi()
        .then(function (res) {
          result = res.data.data
        })
        .catch(function (err) {
          console.log(err)
          // constant.giveMessage('获取目录错误，请联系管理员！', 'error')
        })
      return result
    },

    async getMenuMainApi () {
      let result
      await this.$api.menu.MenuMainApi()
        .then(function (res) {
          result = res.data.data
          sessionStorage.setItem('menuMainData', JSON.stringify(result))
        })
        .catch(function (err) {
          console.log(err)
          // constant.giveMessage('获取目录错误，请联系管理员！', 'error')
        })
      return result
    },
    //处理数据，返回到list中
    handleDataReturnList(p, c, text) {
      let apiDoc = {
        index: text != '3.0接口文档' ? 'apiTypeMenu' : 'apiTypeMenu2',
        img: translation[text != '3.0接口文档' ? 'apiTypeMenu' : 'apiTypeMenu2'].img,
        name: text,
        list: []
      }
      for (let item in p) {
        let tmp = {}
        tmp.name = p[item].chName
        tmp.apiMenu = []
        tmp.entityId = p[item].entityId
        tmp.index = item
        let nowList = c.filter(x => x.type === p[item].entityId)
        if (nowList.length > 0) {
          for (let itemChild in nowList) {
            let tmpChild = {}
            tmpChild.entityId = nowList[itemChild].entityId
            tmpChild.name = nowList[itemChild].chName
            tmpChild.url = nowList[itemChild].url
            tmpChild.switchStatus = nowList[itemChild].switchStatus
            tmp.apiMenu.push(tmpChild)
          }
          apiDoc.list.push(tmp)
        }
      }
      this.datalist.push(apiDoc)
    },
    async initDataList (p, c) {
      if (constant.getUserType() === 1) {
        c = c.filter(x => x.switchStatus === 0)
      }

      this.datalist = []

      // if(!sessionStorage.getItem('token')) {
      if(true) {
        //没登录时
        // 第一段接口文档
        this.handleDataReturnList(p, c, '接口文档')
      } else {
        //登录后区分2.0和3.0
        let p2 = p.filter(item => {
          return item.typeTwo == 2
        })
        let p3 = p.filter(item => {
          return item.typeThree == 3
        })
        let c2 = c.filter(item => {
          return item.interfaceType == 2 || item.interfaceType == 1
        })
        let c3 = c.filter(item => {
          return item.interfaceType == 3 || item.interfaceType == 1
        })
        this.handleDataReturnList(p2, c2, '2.0接口文档')
        this.handleDataReturnList(p3, c3, '3.0接口文档')
      }



      // 第二段安全中心
      let apiSafetyCenterMenu = {
        index: 'apiSafetyCenterMenu',
        img: translation['apiSafetyCenterMenu'].img,
        name: '安全中心',
        list: []
      }

      let that = this
      await this.$api.menu.SafeCenterApi()
        .then(function (r) {
          // 二级菜单为空
          let secMenu = {}
          secMenu.name = '安全中心'
          secMenu.apiMenu = []
          secMenu.entityId = '1'
          secMenu.index = '0'

          if (constant.getUserType() === '0') {
            // 管理员有用户权限的权限
            let userPermission = r.data.data.apiSafetyCenterMenu.filter(x => x.name === '用户权限')

            if (userPermission.length > 0) {
              let tmp = {
                name: userPermission[0].name,
                index: 's-' + userPermission[0].entityId,
                entityId: 's-' + userPermission[0].entityId,
                url: userPermission[0].url
              }
              secMenu.apiMenu.push(tmp)
            }

            // 管理员有系统配置的权限
            let systemConfig = r.data.data.apiSafetyCenterMenu.filter(x => x.name === '系统配置')

            if (systemConfig.length > 0) {
              let tmp = {
                name: systemConfig[0].name,
                index: 's-' + systemConfig[0].entityId,
                entityId: 's-' + systemConfig[0].entityId,
                url: systemConfig[0].url
              }
              secMenu.apiMenu.push(tmp)
            }
          }
          // 白名单
          let whiteList = r.data.data.apiSafetyCenterMenu.filter(x => x.name === 'IP白名单')
          if (whiteList.length > 0) {
            let tmp = {
              name: whiteList[0].name,
              index: 's-' + whiteList[0].entityId,
              entityId: 's-' + whiteList[0].entityId,
              url: whiteList[0].url
            }
            secMenu.apiMenu.push(tmp)
          }
          apiSafetyCenterMenu.list.push(secMenu)
          that.datalist.push(apiSafetyCenterMenu)
        })
        .catch(function (err) {
          console.log(err)
        })
      that.loadNav = true
      if (this.datalist.length > 0) {
        // 默认跳转第一个菜单
        if (this.datalist[0].list.length > 0 && !this.$route.params.id) {
          if (this.datalist[0].list[0].apiMenu.length > 0) {
            let firstChildMenuUrl = this.datalist[0].list[0].apiMenu[0].url
            this.$router.push({ path: constant.pathPre + firstChildMenuUrl })
          }
        }
      } else {
      }
      // this.createdLoadingInstance.close()
    }
  }
}
</script>

<style scoped>
.el-container{
  width: 100%;
  height: 100%;
}
  .el-header{
    width: 100%;
    height: 90px !important;
    padding: 0;
  }
  .el-body{
    height: calc(100% - 90px);
  }
  .el-aside {
    width: 250px !important;
    text-align: center;
    line-height: 33px;
    background: #f7f8f9;
    overflow-x: hidden;
  }
  .el-aside>div{
    height: 100%;
  }
  .el-aside /deep/ .el-menu-item.is-active {
    background: #354ECE0F 0% 0% no-repeat padding-box !important;
    border-left: 4px solid #354ECE;
    padding-left: 76px !important;
    }
  .el-aside /deep/ .el-menu-item.is-active>span {
    margin-left: -4px;
    }
  .el-main {
    text-align: center;
    line-height: 160px;
    padding: 0;
    width: calc(100% - 250px);
    overflow: hidden;
  }
.el-aside /deep/ .content,
.el-aside /deep/ .el-menu,
.el-aside /deep/ .el-menu .el-submenu .el-submenu__title,
.el-aside /deep/ .el-menu .el-submenu .el-menu .el-submenu .el-menu>a>li.el-menu-item{
    background: #f7f8f9;
}
.el-divider{
  display: block;
  height: 1px;
  width: 50%;
  margin: 0 70px;
}

.el-aside /deep/ .el-menu{
  border-right: solid 0px #e6e6e6
}
</style>



// WEBPACK FOOTER //
// src/containers/Home/Index.vue